import { memo } from 'react';
import { defaultAnimateLayoutChanges, useSortable } from '@dnd-kit/sortable';
import { CSS } from '@dnd-kit/utilities';
import { ThumbnailPage, ThumbnailPageProps } from './ThumbnailPage';
import { ThumbnailPageInsertPosition } from '../types';

// Memoised with the default shallow comparison so the grid only re-renders the
// thumbnails that actually changed. The handlers it receives are kept stable by
// their hooks, so listing props by hand would only risk holding on to a stale one.
export const SortableThumbnailPage = memo<ThumbnailPageProps & { activePageIndex: number }>(
  function SortableThumbnailPage({ pageId, pageIndex, activePageIndex, ...props }) {
    const { attributes, listeners, isDragging, over, setNodeRef, transform, transition } = useSortable({
      id: pageId,
      animateLayoutChanges: (args) => defaultAnimateLayoutChanges({ ...args, wasDragging: true }),
    });

    return (
      <ThumbnailPage
        ref={setNodeRef}
        pageId={pageId}
        pageIndex={pageIndex}
        activePageIndex={activePageIndex}
        isDragging={isDragging}
        style={{
          transition,
          transform: CSS.Translate.toString(transform),
        }}
        insertPosition={
          over?.id === pageId
            ? pageIndex > activePageIndex
              ? ThumbnailPageInsertPosition.After
              : ThumbnailPageInsertPosition.Before
            : undefined
        }
        {...props}
        {...attributes}
        {...listeners}
      />
    );
  },
);
